module.exports = __webpack_public_path__ + "img/厨房电器3.00d50c75.jpg";